import { CarrierQualification } from "../CarrierQualification";
import { LaneHistoryTable } from "../LaneHistoryTable";
import { CityState, DataSource, HorizontalSpacer, Label, Layout, LayoutHeader, Panel, SearchPanel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLaneHistory extends Layout {
    citystateCarrier2: CityState;
    citystateCarrier: CityState;
    citystateDestSummary2: CityState;
    citystateDestSummary: CityState;
    citystateOriginSummary2: CityState;
    citystateOriginSummary: CityState;
    citystatePrimary: CityState;
    citystateSecondaryCarrier: CityState;
    citystateStopDestCityId: CityState;
    citystateStopOriginCityId: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacerSearch: HorizontalSpacer;
    labelAddress1: Label;
    labelAssignmentCount: Label;
    labelAssignments: Label;
    labelAverages: Label;
    labelBuyToMarket: Label;
    labelBuyToMarketTotal: Label;
    labelBuyToMarketTotalPercent: Label;
    labelBuyToMarketTotalPercentCalc: Label;
    labelCarrier2: Label;
    labelCarrier: Label;
    labelCarrierNamePrimary: Label;
    labelCarrierNameSecondary: Label;
    labelCarrierNameThird: Label;
    labelCarrierPageAvg: Label;
    labelCarrierPageAvgTitle: Label;
    labelCustomer: Label;
    labelCustomerNamePrimary: Label;
    labelFreightCharge: Label;
    labelFreightChargeCaption: Label;
    labelFreightChargeTota: Label;
    labelIsoKpiScore: Label;
    labelIsoScore: Label;
    labelLabel11: Label;
    labelLabel1: Label;
    labelLabel2: Label;
    labelLabel3: Label;
    labelLabel4: Label;
    labelLabel7: Label;
    labelLabel9: Label;
    labelLane: Label;
    labelMarginPayPer: Label;
    labelMarginPayPerTitle: Label;
    labelMarginPayTotal: Label;
    labelMoveChargeTotal: Label;
    labelOtherChargeCap: Label;
    labelOtherChargeTota: Label;
    labelOtherCharges: Label;
    labelOtherChargesTotal: Label;
    labelPayeeaddress1: Label;
    labelPercentUnassigned: Label;
    labelPercentUnassignedTitle: Label;
    labelPrimaryPayeeAddress1: Label;
    labelSecondaryCarrier: Label;
    labelSecondaryLane: Label;
    labelSecondaryPayeeAddress1: Label;
    labelSummary: Label;
    labelTotalCharge: Label;
    labelTotalChargeAvg: Label;
    labelTotalChargeAvgCap: Label;
    labelTotalPayAvg: Label;
    labelTotalPayAvgCap: Label;
    labelTotalPayTitle: Label;
    labelTotals: Label;
    labelUnassignmentCount: Label;
    labelUnassignments: Label;
    layoutLaneHistoryTable: LaneHistoryTable;
    layoutQualifications: CarrierQualification;
    layoutheaderLaneHist: LayoutHeader;
    panelBuyToMarket: Panel;
    panelCarrierAssignmentHistory: Panel;
    panelCarrierInfo: Panel;
    panelCarrierPay: Panel;
    panelCarrierPrimary: Panel;
    panelCarrierSecondary: Panel;
    panelCarrierThird: Panel;
    panelCustomerPrimary: Panel;
    panelFilterContent: Panel;
    panelFilters: Panel;
    panelFreightCharges: Panel;
    panelIsoScorecardInfo: Panel;
    panelLanePrimary: Panel;
    panelLaneSecondary: Panel;
    panelMarginPaySum: Panel;
    panelMoveCount: Panel;
    panelOtherCharges: Panel;
    panelPrimarySummary: Panel;
    panelQualifications: Panel;
    panelSecondarySummary: Panel;
    panelSummary: Panel;
    panelTitles: Panel;
    panelTotal: Panel;
    panelTotalPaySum: Panel;
    panelfillert: Panel;
    searchpanelFilters: SearchPanel;
    sourceCarrier: DataSource;
    sourceCustomer: DataSource;
    sourceLaneHistory: DataSource;
    switchSearchMode: Switch;
    tabTotals: Tab;
    tabsetTotalAverage: Tabset;
    textboxCarrierSalesRep: Textbox;
    textboxCustomerId: Textbox;
    textboxDateRange: Textbox;
    textboxMovementStatus: Textbox;
    textboxMovementType: Textbox;
    textboxOrderStatus: Textbox;
    textboxOrdersId: Textbox;
    textboxOrdersequipmentTypeId: Textbox;
    textboxOverridePayeeId: Textbox;
    textboxRadius: Textbox;
}
